import type { UtilityContext } from '@change-corgi/core/react/utilityContext';

import { NotFoundError } from 'src/shared/error';

import type { PaginatedContextData, PaginatedData } from 'src/app/shared/contexts/asyncData';

import { LocalDecisionMakers } from './api.graphql';
import type { LocalDecisionMakersQuery, LocalDecisionMakersQueryVariables } from './api.graphql';
import type { LocalDecisionMakersItem } from './types';

type LocalDecisionMakersApiData = PaginatedData<
	LocalDecisionMakersItem,
	{
		totalCount: number;
	}
>;

export type LocalDecisionMakersData = PaginatedContextData<LocalDecisionMakersApiData>;

async function getData(
	{ gql: { fetch } }: UtilityContext,
	slug: string,
	cursor?: string,
): Promise<LocalDecisionMakersApiData> {
	const { data } = await fetch<LocalDecisionMakersQuery, LocalDecisionMakersQueryVariables>({
		query: LocalDecisionMakers,
		variables: { slug, cursor: cursor ?? null },
		rejectOnError: true,
	});

	if (!data.localPageLocation) throw new NotFoundError();

	return {
		items: data.localPageLocation.decisionMakersConnection.nodes,
		cursor: data.localPageLocation.decisionMakersConnection.pageInfo.endCursor,
		hasNextPage: data.localPageLocation.decisionMakersConnection.pageInfo.hasNextPage,
		totalCount: data.localPageLocation.decisionMakersConnection.totalCount,
	};
}

export async function getFirstPageData(utilityContext: UtilityContext, slug: string) {
	return getData(utilityContext, slug);
}

export async function getNextPageData(utilityContext: UtilityContext, cursor: string, slug: string) {
	return getData(utilityContext, slug, cursor);
}
